<div class="col-xs-12">
  <div class="m-t-sm m-b-sm" ng-if="deposito.cd_deposito">
    <historico-alteracoes id="{{deposito.cd_deposito}}" type="Deposito" />
  </div>
  <div class="btn-group">
    <div class="btn btn-default btn-sm btn-action" ng-click="goToIndex()">Voltar</div>
    <div class="btn btn-primary btn-sm btn-action" ng-if="permissions.depositos.canManage" ng-click="edit()">
      Editar <i class="glyphicon glyphicon-pencil"></i>
    </div>
  </div>
</div>